import { render, staticRenderFns } from "./LegendContent.vue?vue&type=template&id=7ca3edf6&scoped=true&"
import script from "./LegendContent.vue?vue&type=script&lang=js&"
export * from "./LegendContent.vue?vue&type=script&lang=js&"
import style0 from "./LegendContent.vue?vue&type=style&index=0&id=7ca3edf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca3edf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemAvatar,VListItemContent,VListItemTitle})
